/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import customMenuSelectTyreCategory from './widgets/menu-select-tyre-category';
import customSliderHits from './widgets/hits-slider';
import { capFirstLetter } from '../../utils';

const slider = document.querySelector('.js-range-slider');

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
    };

    const indexName = `${SWDLocalise.algoliaIndex}tyre`;

    const search = instantsearch({
        searchClient,
        indexName,
        future: {
            preserveSharedStateOnUnmount: true,
        },
    });

    search.addWidgets([
        customMenuSelectTyreCategory({
            container: document.querySelector('.js-range-slider-filter-season'),
            attribute: 'taxonomies.tyre_season',
            sortBy: ['name:asc'],
            transformItems(items) {
                return items.map((item) => ({
                    ...item,
                    label: item.label.split('-')
                        .map(decodeURIComponent)
                        .map(capFirstLetter)
                        .join(' '),
                }));
            },
            title: 'Season',
        }),

        customMenuSelectTyreCategory({
            container: document.querySelector('.js-range-slider-filter-purpose'),
            attribute: 'taxonomies.tyre_type',
            sortBy: ['name:asc'],
            transformItems(items) {
                return items.map((item) => ({
                    ...item,
                    label: item.label.split('-')
                        .map(decodeURIComponent)
                        .map(capFirstLetter)
                        .join(' '),
                }));
            },
            title: 'Purpose',
        }),

        customSliderHits({
            container: slider,
        }),
    ]);

    search.start();
};

const init = () => {
    if (!slider) return;
    setup();
};

export default init;
